import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMemberNew } from './hooks/useMemberNew';
import { MemberFormBlock } from './components/MemberFormBlock';
import type { MemberFormData } from './types/memberNew.types';

export function MemberNewPage() {
  const navigate = useNavigate();
  const { roles, teams, isLoading, isSubmitting, createMember } = useMemberNew();
  
  const [formData, setFormData] = useState<MemberFormData>({
    fullName: '',
    email: '',
    phone: '',
    roleCodes: [],
    teamId: '',
    status: 'active'
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await createMember(formData);
    if (success) {
      navigate('?tab=members');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('?tab=members')}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-slate-100 bg-white text-slate-600 active:scale-95 transition-all"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <div>
            <h1 className="text-lg font-medium text-slate-900">Thêm thành viên mới</h1>
            <p className="text-xs text-slate-500 font-medium">Khởi tạo tài khoản và phân quyền hệ thống</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 gap-4">
        <MemberFormBlock
          formData={formData}
          setFormData={setFormData}
          roles={roles}
          teams={teams}
          isLoading={isLoading}
        />

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
          <button
            type="button"
            onClick={() => navigate('?tab=members')}
            className="h-10 px-6 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-600 hover:bg-slate-50 active:scale-95 transition-all"
          >
            Hủy bỏ
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isLoading}
            className="h-10 px-8 rounded-md bg-emerald-700 text-sm font-medium text-white hover:bg-emerald-800 disabled:opacity-50 active:scale-95 transition-all shadow-md shadow-emerald-700/10"
          >
            {isSubmitting ? 'Đang lưu...' : 'Lưu thông tin'}
          </button>
        </div>
      </div>
    </form>
  );
}
